import { FC } from 'react';
import { observer } from 'mobx-react';
import { Card } from '@servicetitan/anvil2';
import { TitleValue } from './common/title-value';
import { getFString } from '../../utils/get-f-string';
import classNames from 'classnames';
import { TargetSuperHeatResponseDto } from '../../models/taget-super-heat.response.dto';

export const TargetSuperHeatAnswer: FC<{
    data: TargetSuperHeatResponseDto;
    className?: string;
}> = observer(({ data, className }) => {
    return (
        <Card className={classNames('w-100-i', className)}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', rowGap: 12 }}>
                <TitleValue title="Target Superheat" value={getFString(data.target_sh)} />
                <TitleValue title="Safe Operating Range " value={getFString(data.safe_rage)} />
            </div>
        </Card>
    );
});
